import { useSelector } from 'react-redux';

import Button from '#src/components/Button/index.js';
import Link from '#src/components/Link/index.js';
import { getEnvironment } from '#src/store/environment/selectors.js';

import styles from './PaymentError.module.scss';

export function PaymentError({ error, onDismiss }) {
  const { SUPPORT_EMAIL } = useSelector(getEnvironment);
  return (
    <div className={styles.container}>
      <h1>Payment Error</h1>
      <p>
        We encountered an error while attempting to verify your payment
        information.
      </p>
      <Button className={styles.button} onClick={onDismiss}>
        Try Again
      </Button>
      {SUPPORT_EMAIL && (
        <p className={styles.support}>
          <Link href={`mailto:${SUPPORT_EMAIL}`}>or contact support</Link>
        </p>
      )}
    </div>
  );
}
